"use strict";
exports.__esModule = true;
exports.resolveID = void 0;
var uri_1 = require("../../util/uri");
function resolveID(schema, baseURI) {
    if (typeof schema !== 'object') {
        return undefined;
    }
    // $ref prevents a sibling id from changing the base uri
    if ('$ref' in schema) {
        return undefined;
    }
    if ('id' in schema && typeof schema.id === 'string') {
        // TODO?: do absolute and # fragemnt versions?
        return (0, uri_1.resolveURIReference)(schema.id, baseURI);
    }
    return undefined;
}
exports.resolveID = resolveID;
